// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"slice"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2.5 20.5L13 10V18.5C13 19.6046 12.1046 20.5 11 20.5H2.5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M13 17.0003L22.25 7.75026C23.2165 6.78377 23.2165 5.21676 22.25 4.25026C21.2835 3.28377 19.7165 3.28377 18.75 4.25027L13 10.0003L13 17.0003Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13 17.0003L22.25 7.75026C23.2165 6.78377 23.2165 5.21676 22.25 4.25026C21.2835 3.28377 19.7165 3.28377 18.75 4.25026L13 10.0003M13 17.0003V10.0003M13 17.0003V18.5003C13 19.6048 12.1046 20.5003 11 20.5003H2.5L13 10.0003","strokeWidth":"props.strokeWidth"}}]}]};

const SliceIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'slice',
    ref,
    icon: element,
  },
));

SliceIcon.displayName = 'SliceIcon';

export default SliceIcon;
